import { iUserStoreState } from '../../store/user/userSlice';
import { useAppSelector } from '../storeHooks';
export default function useUserInfo() {
  const userInfo: iUserStoreState = useAppSelector((state) => state.user && state.user);
  const isLoggedIn = userInfo.isLoggedIn;
  const userDetails = userInfo.userDetails;
  const isLoading = userInfo.isLoading;
  const apiError = userInfo.apiError;
  const mustChangePassword = isLoggedIn && !!userDetails?.mustChangePassword;

  return { userDetails, isLoading, apiError, isLoggedIn, mustChangePassword };
}
